/** This is a Container.  Place all code
 * portions that deal with the server
 * or Redux in this file.  It is not
 * for handling display templates */

import {connect} from 'react-redux'
import * as actions from './CashFlowChartActions'
import CashFlowChartView from './CashFlowChartView'
import {get_inc_chart_data, get_exp_chart_data, get_inc_total, get_exp_total} from './CashFlowChartSelector'

const mapStateToProps = (state, ownProps) => {
    let subdivision = state.CashFlow[ownProps.clientId]
    return {
        inc_chart_data: get_inc_chart_data(state, ownProps.clientId),
        exp_chart_data: get_exp_chart_data(state, ownProps.clientId),
        is_initialized: subdivision ? subdivision.is_initialized : null,
        inc_total: get_inc_total(state, ownProps.clientId),
        exp_total: get_exp_total(state, ownProps.clientId)
    }
}

const mapDispatchToProps = (dispatch) => ({
    fetch_data(clientId) {
        dispatch(actions.fetch_data(clientId))
    }
})

const CashFlowChart = connect(
    mapStateToProps,
    mapDispatchToProps
)(CashFlowChartView)

export default CashFlowChart